module.exports = __webpack_public_path__ + "img/banner_bg.480fc1b2.jpg";